import { Badge } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";
import { getBrandCustom } from "../../../../../../../../../util/getCustomColor";

export const Wrapper = styled("div")(() => ({
  height: "100%",
}));

export const ContentWrapper = styled("div")(() => ({
  maxWidth: 1142,
  margin: "0 auto",
  padding: "32px 0",
}));

export const MandatoryBadge = styled(Badge)(() => ({
  backgroundColor: "#FEF3F2",
  color: "#D92D20",
  padding: "4px 8px",
  borderRadius: 4,
}));

export const CardsWrapper = styled("div")(() => ({
  padding: "32px 8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 24,
}));

export const ButtonWrapper = styled("div")(() => ({
  backgroundColor: colors.white,
  border: `1px solid ${colors.gray200}`,
  padding: "16px 24px",
  marginTop: 32,
  borderRadius: 8,

  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  gap: 16,
}));

export const HeaderWrapper = styled("div")(() => ({
  padding: "24px 32px",
  backgroundColor: colors.white,
  borderBottom: `1px solid ${colors.gray200}`,
}));

type BreadcrumbItemProps = {
  color?: string;
  hasCursorPointer: boolean;
};

export const BreadcrumbItemSpan = styled("span")(
  ({ color, hasCursorPointer }: BreadcrumbItemProps) => ({
    color: color ? color : getBrandCustom("primaryColor", colors.brandBlue500),
    fontFamily: "Manrope",
    fontSize: 16,
    fontWeight: 600,
    lineHeight: "24px",
    letterSpacing: 0.15,
    cursor: hasCursorPointer ? "pointer" : "default",
  })
);

const styles = makeStyles(() => ({
  buttonInviteUser: {
    width: 132,
  },
  accordionDetailsWrapper: {
    flexDirection: "column",
  },
  radioLabel: {
    display: "flex",
    alignItems: "center",
    "& > label": {
      marginBottom: 0,
      marginRight: 8,
    },
  },
}));

export default styles;
